export default __webpack_public_path__ + "static/media/tutorialWeb-4.1.8c9498cf.png";